import { getProductIdFromProductCode } from '@noths/polaris-client-utils';
import { R3_BRAND, R3_CART, R3_CATEGORY, R3_COMMON, R3_ERROR, R3_GENERIC, R3_HOME, R3_ITEM, R3_PURCHASED, R3_SEARCH } from "./rrJsonApi/rrFacade";
export var setHomepage = function setHomepage() {
  R3_HOME();
};
export var setDepartmentPage = function setDepartmentPage(categoryId) {
  setCategoryPage(categoryId);
};
export var setCategoryPage = function setCategoryPage(categoryId, categoryName) {
  R3_CATEGORY().setId(categoryId);
  if (categoryName) {
    R3_CATEGORY().setName(categoryName);
  }
};
export var setPartnerProductsPage = function setPartnerProductsPage(partnerName) {
  R3_BRAND();
  R3_COMMON().setPageBrand(partnerName);
};
export var setSearchResultsPage = function setSearchResultsPage(searchTerm) {
  R3_SEARCH().setTerms(searchTerm);
};
export var setProductDetailPage = function setProductDetailPage(productCode, productTitle) {
  var itemId = getProductIdFromProductCode(productCode);
  R3_ITEM().setId(String(itemId));
  R3_ITEM().setName(productTitle);
};
export var setGenericPage = function setGenericPage() {
  R3_GENERIC();
};
export var setBasketPage = function setBasketPage() {
  R3_CART();
};
export var setOrderConfirmationPage = function setOrderConfirmationPage() {
  R3_PURCHASED();
};
export var setErrorPage = function setErrorPage() {
  R3_ERROR();
};